import Race981GuideComp from './Race981GuideComp';
import EnRace981GuideComp from './EnRace981GuideComp';
import CnRace981GuideComp from './CnRace981GuideComp';

export { Race981GuideComp, EnRace981GuideComp, CnRace981GuideComp };